import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AssetService } from 'src/app/services/asset.service';
import { RequestAnswerUHNW } from 'src/app/constants/models';
import { DatePipe } from '@angular/common';



@Component({
    selector: 'app-asset-profile',
    templateUrl: './asset-profile.component.html',
    styleUrls: ['./asset-profile.component.scss']
})

export class AssetProfileComponent implements OnInit {
    language = JSON.parse(localStorage.getItem('language'));
    language_flag = localStorage.getItem('language_flag');

    constructor(private _assetService: AssetService, private router: Router, private loader: NgxUiLoaderService) { }
    textInput = ''
    assetProfileStep1 = true;
    assetProfileStep2 = false;
    assetProfileStep_Preview = false;
    isPageHNW = false;
    isPageAngel = false;
    isPageKA = false;
    isSubmit = false;
    isDisabled:String = 'isDisabled';
    isTrue = true;
    isFalse = false;

    isHNW = false;
    isUHNW = false;
    isAngel = false;

    btnPreviewHNW_UHNW = false;
    btnPreviewAngel = false;
    btnAdd_Text_HNW_UHNW = this.language.ap_btn_Add;
    btnAdd_Text_Angel = this.language.ap_btn_Add;


    DocDateHNW_UHNW: string = this.language.ap_could_not_fine;
    EndDateHNW_UHNW: string = this.language.ap_could_not_fine;
    StatusHNW_UHNW: string = this.language.ap_could_not_fine;
    StatusAngel: string = this.language.ap_could_not_fine;

    QuestionnaireStr: string = "";
    QuestionnaireAngelStr: string = this.language.ap_Angel;


    DocDateAngel: string = this.language.ap_could_not_fine;
    EndDateAngel: string = this.language.ap_could_not_fine;


    customerid: Number = 0;

    private personalID: string;
    uid: string;
    AgentID: any;
    isVerifyPid: Boolean;

    listAnswerGroup: Array<any> = [];
    UltraHINWDetail: Array<any> = [];
    AngelDetail: Array<any> = [];
    UltraHNWCheck: Array<any> = [];

    myArrayHNW: Array<any> = [];
    myArrayUHNW: Array<any> = [];
    myArrayAngel: Array<any> = [];
    myArrayKa: Array<any> = [];
    ArrayNW: Array<any> = [];

    resultAnswer: RequestAnswerUHNW = { customerid: 0, type: "", QuestionId: [] };


    resultKa: Array<any> = [];
    AssetKeyObj: object;

    ngOnInit() {
        this.loader.start();
        this.personalID = sessionStorage.getItem('PIDNo');
        this.AgentID = sessionStorage.getItem('AgentID');
        this.isVerifyPid = JSON.parse(sessionStorage.getItem('CType'));
        if (this.personalID == null || this.personalID === '' || this.isVerifyPid == false || sessionStorage.getItem("cusid") == 'undefined' || sessionStorage.getItem("cusid") == null) {
            this.router.navigate(['/fund-service-unit']);
        }
        this.customerid = ((sessionStorage.getItem("cusid") == 'undefined' || sessionStorage.getItem("cusid") == null)) ? this.customerid = 0 : parseInt(sessionStorage.getItem("cusid"))

        this.resultAnswer.customerid = this.customerid;
        this.resultAnswer.type = "Angel";
        this.defaultValue();
    }

    loadQuestionAll() {
        this._assetService.getQuestionAsset(this.customerid, "HNW").subscribe(params => {
            this.loader.start();
            this.myArrayHNW = JSON.parse(JSON.stringify(params));
            this.loader.stop();
        })
        this._assetService.getQuestionAsset(this.customerid, "UHNW").subscribe(params => {
            this.loader.start();
            this.myArrayUHNW = JSON.parse(JSON.stringify(params));
            this.loader.stop();
        })
        this._assetService.getQuestionAsset(this.customerid, "Angel").subscribe(params => {
            this.loader.start();
            this.myArrayAngel = JSON.parse(JSON.stringify(params));
            this.loader.stop();
        })

    }


    defaultValue() {
        this.loadQuestionAll()
        this.loadProfile("Profile");
        this.assetProfileStep1 = true;
        this.assetProfileStep2 = false;

        this.isPageHNW = false;
        this.isPageAngel = false;
        this.isPageKA = false;
        this.isSubmit = false;
        this.isHNW = false;
        this.isUHNW = false;
        this.isAngel = false;

        this.assetProfileStep_Preview = false

        this.ArrayNW = [];

        this.listAnswerGroup = [];
        this.UltraHINWDetail = [];
        this.resultAnswer.customerid = this.customerid;
        this.resultAnswer.type = "Angel";
        this.resultAnswer.QuestionId = [];



    }

    changType(type: String) {
        this.resultAnswer.QuestionId = [];
        this.isSubmit = true;
        if (type == "hnw") {
            this.ArrayNW = this.myArrayHNW;
            this.resultAnswer.type = type;
        }
        else if (type == "uhnw") {
            this.ArrayNW = this.myArrayUHNW
            this.resultAnswer.type = type;
        }
        else {
            this.ArrayNW = [];
            this.resultAnswer.type = type;
        }
    }

    addProfile(type: String) {
        this.assetProfileStep1 = false;
        this.assetProfileStep2 = true;
        if (type == "HNW") {
            this.isPageHNW = true;
            this.isPageAngel = false;
            this.isPageKA = false;
        }
        else if (type == "Angel") {
            this.isPageHNW = false;
            this.isPageAngel = true;
            this.isPageKA = false;

            this.isHNW = false;
            this.isUHNW = false;
            this.isAngel = true;
        }
    }

    previewProfile(type: String) {
        this.loader.start();
        this.assetProfileStep1 = false;
        this.assetProfileStep_Preview = true;
        this.loadProfile("Answer");
        if (type != "Angel") {
            if (this.UltraHINWDetail["detail"]["type"] == "HNW") {
                this.ArrayNW = this.myArrayHNW
                this.isHNW = true;
                this.isUHNW = false;
                this.isAngel = false;
            }
            else if (this.UltraHINWDetail["detail"]["type"] == "UHNW") {
                this.ArrayNW = this.myArrayUHNW
                this.isHNW = false;
                this.isUHNW = true;
                this.isAngel = false;
            }
        }
        else {
            this.ArrayNW = this.myArrayAngel
            this.isHNW = false;
            this.isUHNW = false;
            this.isAngel = true;
        }

        setTimeout(() => {
            this.ArrayNW.forEach((item) => {
                item.SupQuestions.forEach((item2) => {
                    const item2_id = "#checkbox_" + item2.SubQuestionId;
                    $(item2_id).prop("disabled", true);
                    item2.sups.forEach((item3) => {
                        const item3_id = "#checkbox_" + item3.SubQuestionId;
                        $(item3_id).prop("disabled", true);
                    })
                })
            })
            
        }, 1000);

        this.loader.stop();
    }


    addAnswerUltraHNW(questionid) {
        // const question = resultAnswer
        let question = this.resultAnswer.QuestionId;
        const findIndex = question.indexOf(questionid);
        if (findIndex > -1) {
            this.resultAnswer.QuestionId.splice(findIndex, 1);
        }
        else {
            this.resultAnswer.QuestionId.push(questionid);
        }
        console.log(this.resultAnswer)

    }

    cancelProfile() {
        this.defaultValue();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    submitAssetProfile() {

        $('#warningModalConfirm').modal('show');
        window.scrollTo({ top: 0, behavior: 'smooth' });
        // this.defaultValue();
        // window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    userComfirm() {
        $('#warningModalConfirm').modal('hide');
        this.loader.start();
        const promiseA = new Promise( (resolve, reject) => {
            this._assetService.saveUltraHNW(this.resultAnswer).subscribe(params => {
                resolve(params);
            })
        });
        promiseA.then(() => {
            this.defaultValue();
        } );

        this.defaultValue();
        //location.reload();
        //this.router.navigate(['/client-report/', 'AP']);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    userCancel() {
        $('#warningModalConfirm').modal('hide');
    }


    previouEservice() {
        this.router.navigate(['/client-report/', 'ED']);
    }

    loadProfile(page: String) {
        let datePipe = new DatePipe("en-US");
        this._assetService.getAssetDetail(this.customerid, "HNW").subscribe(params => {
            if (params["Data"] != "") {
                this.UltraHINWDetail = JSON.parse(JSON.stringify(params));
                if (page == "Answer") {
                    this.disableCheckbox(params);
                    for (var i = 0; i < params["detail"]["Result"].length; i++) {
                        for (let l = 0; l < params["check"].length; l++) {
                            const id = "#checkbox_" + params["check"][l]["SubQuestionId"]
                            if (params["detail"]["Result"][i]["AnswerId"] == params["check"][l]["AnswerId"]) {
                                $(id).prop('checked', true);
                            }
                        }
                    }
                    this.QuestionnaireStr = (params["detail"]["type"] == "HNW") ? this.language.ap_HNW : this.language.ap_UHNW;
                }
                else if (page == "Profile" && params["detail"]["type"] != "Angel") {
                    const d = new Date(params["detail"]["DocDate"]);
                    const e = new Date(params["detail"]["EndDate"]);

                    if(this.language_flag === 'th'){
                        d.setFullYear(d.getFullYear() + 543);
                        e.setFullYear(e.getFullYear() + 543);
                    }

                    this.DocDateHNW_UHNW = datePipe.transform(d, 'dd/MM/yyyy')
                    this.EndDateHNW_UHNW = datePipe.transform(e, 'dd/MM/yyyy')

                    this.btnPreviewHNW_UHNW = true;
                    this.btnAdd_Text_HNW_UHNW = this.language.ap_btn_Edit
                    this.StatusHNW_UHNW = (params["detail"]["IsPass"]) ? this.language.ap_is_Pass : this.language.ap_is_NotPass;
                }

            }
            else {
                this.btnPreviewHNW_UHNW = false;
                this.btnAdd_Text_HNW_UHNW = this.language.ap_btn_Add
            }

        })

        this._assetService.getAssetDetail(this.customerid, "Angel").subscribe(params => {
            if (params["Data"] != "") {
                this.AngelDetail = JSON.parse(JSON.stringify(params));
                if (page == "Answer") {
                    this.disableCheckbox(params);
                    for (var i = 0; i < params["detail"]["Result"].length; i++) {
                        for (let l = 0; l < params["check"].length; l++) {
                            const id = "#checkbox_" + params["check"][l]["SubQuestionId"]
                            if (params["detail"]["Result"][i]["AnswerId"] == params["check"][l]["AnswerId"]) {
                                $(id).prop('checked', true);
                            }
                        }
                    }
                }
                else if (page == "Profile" && params["detail"]["type"] == "Angel") {
                    const d = new Date(params["detail"]["DocDate"]);
                    const e = new Date(params["detail"]["EndDate"]);

                    if(this.language_flag === 'th'){
                        d.setFullYear(d.getFullYear() + 543);
                        e.setFullYear(e.getFullYear() + 543);
                    }


                    this.DocDateAngel = datePipe.transform(d, 'dd/MM/yyyy')
                    this.EndDateAngel = datePipe.transform(e, 'dd/MM/yyyy')

                    this.btnPreviewAngel = true;
                    this.btnAdd_Text_Angel = this.language.ap_btn_Edit;
                    this.StatusAngel = (params["detail"]["IsPass"]) ? this.language.ap_is_Pass : this.language.ap_is_NotPass;
                }
            }
            else {
                this.btnPreviewAngel = false;
                this.btnAdd_Text_Angel = this.language.ap_btn_Add;
            }

        })
    }

    disableCheckbox(param){
        for (let l = 0; l < param["check"].length; l++) {
            const id = "#checkbox_" + param["check"][l]["SubQuestionId"]
            $(id+"~.checkmark").addClass("clDisable");
        }
    }

}